module.exports = __webpack_public_path__ + "app-static/img/09.0d50c202.jpg";